<script setup>
import UiIcon from "../ui/UiIcon.vue";

defineProps({
  currentIndex: {
    type: Number,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
});

defineEmits(["previous", "next"]);
</script>

<template>
  <div class="flex items-center gap-1 mt-0.5">
    <UiIcon
      name="construction"
      :size="12"
      class="text-[var(--color-warning)] shrink-0"
    />
    <button
      :disabled="currentIndex <= 0"
      class="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 rounded-lg text-xs text-[var(--color-focus)] hover:bg-[#334155] transition-all cursor-pointer"
      @click="$emit('previous')"
    >
      ◀ Prev bridge
    </button>
    <span class="text-xs text-[#94a3b8] min-w-[30px] text-center">
      {{ currentIndex >= 0 ? currentIndex + 1 : "–" }}/{{ count }}
    </span>
    <button
      :disabled="currentIndex >= count - 1"
      class="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 rounded-lg text-xs text-[var(--color-focus)] hover:bg-[#334155] transition-all cursor-pointer"
      @click="$emit('next')"
    >
      Next bridge ▶
    </button>
  </div>
</template>
